import { NavTarget } from '../../../components/link/link.component';
import { Component, Input, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { GrundstueckDetailEntryMeta } from '../../../../core/gb-api';
import { GrundstueckArtPipe } from '../../../pipes/simple/grundstueck-art.pipe';
import { GrundstuecknummerPipe } from '../../../pipes/simple/grundstuecknummer.pipe';
import { KompaktdarstellungTemplateComponent } from '../../kompakt-darstellung-template.component';
import { FormatConfigService } from '../../../../core/services/format-config.service';
import { NgTemplateOutlet, PlatformLocation } from '@angular/common';
import { ComponentLocationStrategy } from '../../../services/location-strategy/component-location-strategy';
import { Subscription } from 'rxjs';
import { GrundstueckArtLangPipe } from '../../../pipes/simple/grundstueck-art-lang.pipe';

@Component({
  selector: 'cap-kompakt-grundstueck-detail',
  templateUrl: './kompakt-grundstueck-detail.component.html',
  preserveWhitespaces: false,
  imports: [NgTemplateOutlet]
})
export class KompaktGrundstueckDetailComponent extends KompaktdarstellungTemplateComponent implements OnInit, OnDestroy {
  navTargets = NavTarget;

  private _item: GrundstueckDetailEntryMeta;
  protected language: string;

  @ViewChild('typ00', { static: true }) typ00Template: TemplateRef<any>;
  @ViewChild('typ01', { static: true }) typ01Template: TemplateRef<any>;
  @ViewChild('typ02', { static: true }) typ02Template: TemplateRef<any>;

  gsTyp00: string;
  gsTyp01: string;
  gsTyp02: string;

  private subscription: Subscription;

  constructor(
    protected formatService: FormatConfigService,
    location: PlatformLocation,
    locationStrategy: ComponentLocationStrategy,
    private translate: TranslateService,
    private grundstArtPipe: GrundstueckArtPipe,
    private grundstArtLangPipe: GrundstueckArtLangPipe,
    private grundstueckNummerPipe: GrundstuecknummerPipe
  ) {
    super(formatService, 'GRUNDSTUECK', location, locationStrategy);

    this.subscription = this.translate.onLangChange.subscribe((language) => {
      this.language = language.lang;
      this.calculateTextRepresenation();
    });
  }

  ngOnInit() {
    super.ngOnInit();
    this.calculateTextRepresenation();
  }

  private calculateTextRepresenation() {
    if (!this._item) {
      return;
    }
    const kopie = this._item.isKopie ? ' (' + this.translate.instant('GrundstückKopie') + ')' : '';
    const value = this.grundstueckNummerPipe.transform(this._item.grundstueckNummern[this._item.grundstueckNummern.length - 1]) + kopie;
    this.gsTyp00 = this.grundstArtPipe.transform(this._item, this.language) + ' ' + value;
    this.gsTyp01 = value;
    this.gsTyp02 = this.grundstArtLangPipe.transform(this._item, this.language) + ' ' + value;
  }

  registerTemplates() {
    this.bindTemplates(this.typ00Template, 'GRUNDSTUECK_TYP00');
    this.bindTemplates(this.typ01Template, 'GRUNDSTUECK_TYP01');
    this.bindTemplates(this.typ02Template, 'GRUNDSTUECK_TYP02');
  }

  getDefaultTemplate(): TemplateRef<any> {
    return this.typ00Template;
  }

  @Input()
  set item(value: GrundstueckDetailEntryMeta) {
    this._item = value;
    this.calculateTextRepresenation();
  }

  get item(): GrundstueckDetailEntryMeta {
    return this._item;
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
